import { create } from 'zustand';

const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  authState: 'signIn', // signIn | signUp | confirmSignUp | authenticated
  pendingEmail: '',
  error: '',
  showAuthModal: false,

  setUser: (user) => set({ user, isAuthenticated: !!user, authState: user ? 'authenticated' : 'signIn' }),
  clearAuth: () => set({ user: null, isAuthenticated: false, authState: 'signIn' }),
  setAuthState: (authState) => set({ authState }),
  setPendingEmail: (email) => set({ pendingEmail: email }),
  setError: (err) => set({ error: err || '' }),
  setLoading: (isLoading) => set({ isLoading }),
  openAuthModal: () => set({ showAuthModal: true, error: '', authState: 'signIn' }),
  closeAuthModal: () => set({ showAuthModal: false, error: '' }),
}));

export default useAuthStore;
